// @ts-nocheck
/* eslint-disable */
export const dotIcon = {
    data: `<?xml version="1.0" encoding="utf-8"?><svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.8 10a2.2 2.2 0 0 0 4.4 0 2.2 2.2 0 0 0-4.4 0z"/></svg>`,
    name: 'dot' as const
};